import { render, staticRenderFns } from "./YakoueEditor.vue?vue&type=template&id=0928f312&scoped=true&"
import script from "./YakoueEditor.vue?vue&type=script&lang=js&"
export * from "./YakoueEditor.vue?vue&type=script&lang=js&"
import style0 from "./YakoueEditor.vue?vue&type=style&index=0&id=0928f312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928f312",
  null
  
)

export default component.exports